import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useVerifyTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/verify", {
        data,
      }),
  });

export const useCreateTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/create", {
        data,
        successMessage: "Ticket has been created successfully",
      }),
  });

export const useAddSite = () =>
  useMutation({
    mutationFn: (data) =>
      client("common/create/tgsisite", {
        data,
        successMessage: "Site has been added successfully",
      }),
  });
export const useCreateCall = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/create/cc", {
        data,
        successMessage: "Ticket has been created successfully",
      }),
  });
export const useCreateBulkTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/create/bulk/v2", {
        data,
        successMessage: "Ticket in bulk has been created successfully",
      }),
  });
export const useSelfAssignTicket = () =>
  useMutation({
    mutationFn: (requestID) =>
      client(`tickets/self/assign/${requestID}`, {
        method: "post",
        successMessage: "Ticket has been assigned successfully",
      }),
  });
export const useCloseBulkTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/close/bulk", {
        data,
        successMessage: "Ticket in bulk has been closed successfully",
      }),
  });
export const useCloseBulkCashTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/cash/bulk/close/v2", {
        data,
        successMessage: "Ticket in bulk has been closed successfully",
      }),
  });
export const useSaveTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/save", {
        data,
        successMessage: "Ticket has been saved",
      }),
  });
export const useSaveCall = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/save/cc", {
        data,
        successMessage: "Ticket has been saved",
      }),
  });
export const useAddTicketNotes = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/add/notes", {
        data,
        successMessage: "Notes has been added successfully",
      }),
  });
export const useGetAssignedTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/assigned", {
        data,
      }),
  });
export const useGetCashTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/cash", {
        data,
      }),
  });
export const useGetAllTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/all", {
        data,
      }),
  });

export const useGetOpenTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/open", {
        data,
      }),
  });

export const useGetVaultedTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/vault/access", {
        data,
      }),
  });
export const useGetAwaitingTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/awaiting", {
        data,
      }),
  });
export const useGetResolvedTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/resolved", {
        data,
      }),
  });
export const useGetClosedTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/closed", {
        data,
      }),
  });
export const useGetCancelledTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/cancelled", {
        data,
      }),
  });
export const useUpdateTicketStatus = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/update/status", {
        data,
        successMessage: "Status has been updated successfully",
      }),
  });

export const useAddNotes = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/add/notes", {
        data,
        successMessage: "Notes has been added successfully",
      }),
  });
export const useGetTicketDetails = () =>
  useMutation({
    mutationFn: (ticketId) => client(`tickets/details/${ticketId}`),
  });
export const useGetTaskDetails = () =>
  useMutation({
    mutationFn: (requestId) => client(`tickets/task/details/${requestId}`),
  });

export const useUpdateTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/edit`, {
        data,
        successMessage: "Ticket has been updated successfully",
      }),
  });

export const useUpdateTask = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/edit/task`, {
        data,
        successMessage: "Task has been updated successfully",
      }),
  });
export const useDeleteTicket = () =>
  useMutation({
    mutationFn: (ticketId) =>
      client(`tickets/delete/${ticketId}`, {
        successMessage: "Ticket has been deleted successfully",
      }),
  });
export const useGetJobCards = () =>
  useMutation({
    mutationFn: (requestId) => client(`tickets/job/card/${requestId}`),
  });

export const useSubmitTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/submit`, {
        data,
        successMessage: "Ticket has been created successfully",
      }),
  });
export const useGetTicketsByLocation = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/location/services`, { data }),
  });
export const useVerifyBankReference = () =>
  useMutation({
    mutationFn: (reference) =>
      client(`tickets/check/bank/reference/${reference}`),
  });
export const useGetTasks = () =>
  useMutation({
    mutationFn: (ticketId) => client(`tickets/tasks/${ticketId}`),
  });
export const useExportAllTickets = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/export/all`, { data }),
  });
export const useExportTickets = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/export`, { data }),
  });
export const useExportCashTickets = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/export/cash`, { data }),
  });
export const useGetAllCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/all/cc`, { data }),
  });
export const useExportAllCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/export/all/cc`, { data }),
  });
export const useGetOpenCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/open/cc`, { data }),
  });
export const useGetCashCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/cash`, { data }),
  });
export const useExportCashCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/export/cash`, { data }),
  });
export const useGetAssignedCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/assigned/cc`, { data }),
  });
export const useGetResolvedCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/resolved/cc`, { data }),
  });
export const useGetClosedCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/closed/cc`, { data }),
  });
export const useGetCancelledCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/cancelled/cc`, { data }),
  });
export const useExportCalls = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/export/cc`, { data }),
  });
export const useUploadUnderReplenishmentSite = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/upload/under/replenishment/site", {
        data,
        successMessage: "Operation successful",
      }),
  });

export const useGetMyCalls = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/my/calls", {
        data,
      }),
  });
export const useExportMyCalls = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/my/calls/export", {
        data,
      }),
  });
export const useGetPanicAlertCalls = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/panic/alert/incidents", {
        data,
      }),
  });
export const useUpdatePanicAlertCalls = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/panic/alert/incidents/edit", {
        data,
      }),
  });
export const useGetIncidentCalls = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/incidents", {
        data,
      }),
  });
export const useGetALLServiceAndNonServiceTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/all/ServiceAndNonServiceTickets", {
        data,
        successMessage: "Ticket updated successfully",
      }),
  });
export const useExportALLServiceAndNonServiceTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/export/all/ServiceAndNonServiceTickets", {
        data,
      }),
  });
export const useCreateIncidentTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/incidents/create", {
        data,
        successMessage: "Ticket created successfully",
      }),
  });
export const useSaveIncidentTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/incidents/save", {
        data,
        successMessage: "Ticket created successfully",
      }),
  });
export const useSubmitIncidentTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/incidents/submit", {
        data,
        successMessage: "Ticket created successfully",
      }),
  });

export const useGetIncidentTicketDetails = () =>
  useMutation({
    mutationFn: (ticketId) => client(`tickets/incidents/${ticketId}`),
  });
export const useGetIncidentDetails = () =>
  useMutation({
    mutationFn: (requestId) => client(`tickets/incidents/details/${requestId}`),
  });
export const useUpdateIncidentTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/incidents/update", {
        data,
        successMessage: "Ticket updated successfully",
      }),
  });
export const useDeleteIncidentAttachment = () =>
  useMutation({
    mutationFn: (data) =>
      client(
        `tickets/incidents/delete/attachment/${data.incidentId}/${data.filedId}`,
        {
          method: "delete",
          successMessage: "Attachment has been successfully deleted",
        }
      ),
  });

export const useUpdateIncidentTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/incidents/update`, {
        data,
        successMessage: "Ticket has been updated successfully",
      }),
  });

export const useGetPanicAlertTasks = () =>
  useMutation({
    mutationFn: (ticketId) =>
      client(`tickets/panic/alert/incidents/tasks/${ticketId}`),
  });

export const useUpdatePanicAlertTicketStatus = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/panic/alert/incidents/update/status`, {
        data,
        successMessage: "Task has been updated successfully",
      }),
  });
export const useExportIncidentTickets = () =>
  useMutation({
    mutationFn: (data) => client(`tickets/incidents/export`, { data }),
  });
export const useExportPanicAlertIncidentTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/panic/alert/incidents/export`, { data }),
  });
